export const activity = {
  activityWebEmptyStateTitle: 'Brak aktywności',
  activityWebEmptyStateText: 'Tutaj będzie twój przegląd powiadomień',
  activitySeeAll: 'Zobacz wszystko',
  in: 'w'
}
